/**
 * PostHog Analytics Configuration
 *
 * Cloud setup for testing - will migrate to self-hosted later
 * Migration: Just change VITE_POSTHOG_HOST environment variable
 */

import posthog from 'posthog-js';

if (typeof window !== 'undefined') {
  posthog.init(
    import.meta.env.VITE_POSTHOG_KEY,
    {
      api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com',

      // Session Recording - record user sessions for debugging
      session_recording: {
        recordCrossOriginIframes: true,
        maskAllInputs: false,
        maskInputOptions: {
          password: true,      // Always mask passwords
          email: false,        // Don't mask email (useful for support)
          color: false,
          date: false,
          'datetime-local': false,
          month: false,
          number: false,
          range: false,
          search: false,
          tel: false,
          text: false,
          time: false,
          url: false,
          week: false,
          textarea: false,
          select: false,
          radio: false,
          checkbox: false
        }
      },

      // Auto-capture clicks, pageviews, etc.
      autocapture: true,

      // Capture Web Vitals (LCP/FCP/INP/CLS) so we get real page-load timing
      // across all users without per-page instrumentation.
      capture_performance: { web_vitals: true },

      // Capture console logs in session recordings
      enable_recording_console_log: true,

      // Privacy settings
      respect_dnt: true,  // Respect Do Not Track browser setting
      opt_out_capturing_by_default: false,

      // Performance & debugging
      loaded: (posthog) => {
        if (import.meta.env.DEV) {
          console.log('PostHog Analytics loaded');
          console.log('PostHog Host:', import.meta.env.VITE_POSTHOG_HOST || 'https://app.posthog.com');
        }
      }
    }
  );

  // Global error handlers - capture uncaught errors
  window.addEventListener('error', (event) => {
    if (posthog) {
      posthog.captureException(event.error || new Error(event.message), {
        message: event.message,
        filename: event.filename,
        lineno: event.lineno,
        colno: event.colno,
        type: 'uncaught_exception'
      });
    }
  });

  // Capture unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    if (posthog) {
      posthog.captureException(
        event.reason instanceof Error ? event.reason : new Error(String(event.reason)),
        {
          type: 'unhandled_promise_rejection',
          reason: String(event.reason)
        }
      );
    }
  });
}

export default posthog;
